import { TNameTitle } from '@interfaces/common/common';

export const tooltipContent = 'The vendor cannot be turned off due to the presence of sites';

export const getConfirmChangeStatusText = (vendorName: string) => {
	return `Are you sure you want to deactivate the ${vendorName} vendor within your organisation?`;
};

export interface IDataForEditInterface {
	vendor: TNameTitle;
	status: boolean;
	maxKpiSelectionInCharts?: number;
}
